import { ItiBaseDto } from '@/iti-core-vue';

export class Association extends ItiBaseDto {
    public code !: string;
    public description !: string;
}